import i18next from "i18next";
import { z } from "zod";
import { zodI18nMap } from "zod-i18n-map";
import ZOD_ERROR_MESSAGE_JA from "zod-i18n-map/locales/ja/zod.json";

// 入力が必須の項目です を入れる変数を定義
const REQUIRED_TEXT = "入力が必須の項目です";

/**
 * zodのエラーメッセージをi18nする（日本語で表示できるようにする）
 */
export function zodI18nInit() {
	i18next.init({
		lng: "ja",
		resources: {
			ja: {
				zod: {
					...ZOD_ERROR_MESSAGE_JA,
					errors: {
						...ZOD_ERROR_MESSAGE_JA.errors,
						invalid_type_received_undefined: REQUIRED_TEXT,
						invalid_type_received_null: REQUIRED_TEXT,
						invalid_string: {
							email: "メールアドレスの形式で入力してください",
							url: `"https://" から始まる、URLの形式で入力してください`,
							uuid: "UUIDの形式で入力してください",
							cuid: "CUIDの形式で入力してください",
							regex: "正しい形式で入力してください",
							datetime: "日時の形式で入力してください",
							startsWith: "指定された文字で始まる必要があります",
							endsWith: "指定された文字で終わる必要があります",
						},
						too_small: {
							...ZOD_ERROR_MESSAGE_JA.errors.too_small,
							string: {
								exact: "{{minimum}}文字以上を入力してください",
								inclusive: "{{minimum}}文字以上を入力してください",
								not_inclusive: "{{minimum}}文字より多くの文字数を入力してください",
							},
							number: {
								exact: "{{minimum}}である必要があります",
								inclusive: "{{minimum}}以上の数字を入力してください",
								not_inclusive: "{{minimum}}より大きな数字を入力してください",
							},
						},
						too_big: {
							...ZOD_ERROR_MESSAGE_JA.errors.too_big,
							string: {
								exact: "{{maximum}}文字以下で入力してください",
								inclusive: "{{maximum}}文字以下で入力してください",
								not_inclusive: "{{maximum}}文字より短い文字数を入力してください",
							},
							number: {
								exact: "{{maximum}}である必要があります",
								inclusive: "{{maximum}}以下の数字を入力してください",
								not_inclusive: "{{maximum}}より小さな数字を入力してください",
							},
						},
					} as const satisfies typeof ZOD_ERROR_MESSAGE_JA.errors,
				},
			},
		},
	});
	z.setErrorMap(zodI18nMap);
}
